export default __webpack_public_path__ + "static/media/JCB.03279db7.svg";